<template>
  <div class="wrapper hefei-bg-f5">
    <div class="msgcenter">
      <div class="container-wrap-form">
        <div class="form-bg msg-list">
          <div class="msg-item">
            <div class="img-left">
              <img
                v-if="doctorInfo.gender === '1'"
                :class="{'grayscale':doctorInfo.onlineStatus!='1'}"
                :src="doctorInfo.imgUrl?doctorInfo.imgUrl:defaultMaleAvatarUrl"
                :onerror="getDefaultAvatarUrl('1')"
                alt="maleAvatar"
              />
              <img
                v-else
                :class="{'grayscale':doctorInfo.onlineStatus!='1'}"
                :src="doctorInfo.imgUrl?doctorInfo.imgUrl:defaultFemaleAvatarUrl"
                :onerror="getDefaultAvatarUrl('2')"
                alt="femaleAvatar"
              />
              <span
                class="is-online"
                :class="doctorInfo.onlineStatus === '1'? '':'leave'"
              >{{ doctorInfo.onlineStatus === '1' ? '在线':'离线' }}</span>
            </div>
            <div class="img-content">
              <div class="clearfix msg-info">
                <p class="fn-fl msg-con">
                  <span>{{ doctorInfo.name }}</span>
                  <i>{{ doctorInfo.postName }}</i>
                </p>
              </div>
              <div class="doc-follow" :class="{active: active}" @click="changeActive">
                <i></i>
                <span>{{ isFollow ? '已关注':'关注' }}</span>
              </div>
              <p class="msg-tip">{{ doctorInfo.phospName || '' }}</p>
              <!-- <p class="msg-tip">{{ doctorInfo.phospName || '' }} | {{ doctorInfo.deptName }}</p> -->
              <p class="msg-tip">
                <span>咨询量 {{ doctorInfo.consultCnt || 0}}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="form-bg doc-home">
          <ul class="form-table">
            <li class="table-left" @click="handleConsult('img')">
              <div class="icon-img">
                <img v-if="doctorInfo.statusImage === '1'" src="../../assets/images/jidayi-hospital/icon-opt-img.png" alt />
                <img v-else src="../../assets/images/jidayi-hospital/icon-opt-img2.png" alt />
              </div>
              <h3 :class="doctorInfo.statusImage === '1'?'':'gray'">图文咨询</h3>
              <h4
                :class="doctorInfo.statusImage === '1' ? '':'gray'"
              >{{ doctorInfo.statusImage === '1' ? (isMini?`${doctorInfo.costsImage || ''}元/次`:`免费`):'暂未开通' }}</h4>
            </li>
            <li class="table-left" @click="handleConsult('video')">
              <div class="icon-img">
                <img v-if="doctorInfo.statusVideo === '1' && isMini" src="../../assets/images/jidayi-hospital/icon-opt-video.png" alt />
                <img v-else src="../../assets/images/jidayi-hospital/icon-opt-video2.png" alt />
              </div>
              <h3 :class="doctorInfo.statusVideo === '1' && isMini?'':'gray'">视频咨询</h3>
              <h4
                :class="doctorInfo.statusVideo === '1' && isMini ? '':'gray'"
              >{{ doctorInfo.statusVideo === '1' && isMini? `${doctorInfo.costsVideo || ''}元/次`:'暂未开通' }}</h4>
            </li>
            <li class="table-left" @click="handleConsult('tel')">
              <div class="icon-img">
                <img v-if="doctorInfo.statusTel === '1'" src="../../assets/images/jidayi-hospital/icon-opt-tel.png" alt />
                <img v-else src="../../assets/images/jidayi-hospital/icon-opt-tel2.png" alt />
              </div>
              <h3 :class="doctorInfo.statusTel === '1'?'':'gray'">电话咨询</h3>
              <h4
                :class="doctorInfo.statusTel === '1' ? '':'gray'"
              >{{ doctorInfo.statusTel === '1' ? `${doctorInfo.costsTel || ''}元/次`:'暂未开通' }}</h4>
            </li>
          </ul>
        </div>

        <!-- <div class="form-bg">
          <div class="common-title">
            <span>专业擅长</span>
          </div>
          <div class="good-at">
            <p :class="{unfold: fold}">
              {{ doctorInfo.doctorSkill || '暂无描述'}}
              <i v-if="doctorInfo.doctorSkill" @click="fold=!fold"></i>
            </p>
          </div>
        </div> -->

        <div class="form-bg">
          <div class="common-title">
            <span>医生介绍</span>
          </div>
          <div class="good-at">
            <p>{{ doctorInfo.introduce || '暂无描述'}}</p>
          </div>
        </div>

      </div>
    </div>
    <schedulPicker
      ref="schedulPicker"
      :doctorInfo="doctorInfo"
      :dataList="pickerDataList"
      @closePicker="closePicker"
      @createForm="enterCounsulation"
      v-if="pickerFlag">
    </schedulPicker>
  </div>
</template>
<script>
import * as $services from "@/services/index";
import schedulPicker from "../common/schedulPicker";
export default {
  components: {
    schedulPicker
  },
  data() {
    return {
      isMini: false,
      defaultFemaleAvatarUrl: require("../../assets/images/jidayi-hospital/icon-doctor-female.png"),
      defaultMaleAvatarUrl: require("../../assets/images/jidayi-hospital/icon-doctor-male.png"),
      active: false,
      fold: true,
      params: {
        deptId:"",
        staffId: ""
      },
      doctorInfo: {},
      pickerDataList: [],
      channelSelectedType: '',
      schedulDayList: [],
      pickerFlag: false,
      isFollow: false,
      popupVisible: false,
      hospitalsList: [],
      isConsult: '0',
      channelType: {
        // 在线咨询
        '0': {
          'img': '01',
          'video': '02'
        },
        // 在线复诊
        '1': {
          'img': '03',
          'video': '04'
        },
      },
      costMap: {
        '01': 'costsImage', //图文咨询
        '02': 'costsVideo', //视频咨询
        '03': 'costsImage', //图文复诊
        '04': 'costsVideo'//视频复诊
      },
    };
  },
  computed: {

  },
  created() {
    if(!this.$route.query.platId && this.$store.getters.platId){
      var query = {};
      for(var i in this.$route.query){
        query[i] = this.$route.query[i]
      }
      query.platId = this.$store.getters.platId;
      this.$router.replace({query: query});
    }
    this.isMini = this.$store.getters.platform === 'mp'? true : false;
    // 判断用户入口，区别在线咨询和在线复诊
    this.isConsult = this.$route.query.isConsult || '0'
    if (this.isConsult === '1') {
      window.document.title = '在线复诊'
    } else {
      if(this.$store.getters.platId == 'T2021052404340500001'){
        window.document.title = "健康咨询";
      }else{
        window.document.title = "医生咨询";
      }
    }
    this.getDoctorInfo();
  },
  mounted() {
  },
  methods: {
    getDefaultAvatarUrl(gender) {
      if (gender === '1') {
        return `this.src='${this.defaultMaleAvatarUrl}'`
      } else {
        return `this.src='${this.defaultFemaleAvatarUrl}'`
      }
    },
    changeActive() {
      if(this.$store.getters.token){
        this.followDoctor();
      }else{
        this.$router.push({ path: "/userReg", query: {platId: this.$route.query.platId,staffId:this.params.staffId}});
      }
    },
    getDoctorInfo() {
      this.params.deptId = this.$route.query.deptId;
      this.params.staffId = this.$route.query.staffId;
      if (this.isConsult === '1') {
        this.params.isRetreat = '1'
      }
      this.$http
        .getDoctorInfoDetail(this.params)
        .then(res => {
          if (res) {
            this.doctorInfo = res || {};
            this.isFollow = this.doctorInfo.isFollow === "1" ? true : false;
            this.active = this.doctorInfo.isFollow === "1" ? true : false;
          } else {
            this.$toast("暂无数据!");
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    followDoctor() {
      let type = "1";
      if (!this.isFollow) {
        type = "0";
      }
      this.$http
        .followDoctor({ doctorId: this.doctorInfo.staffId, type: type })
        .then(res => {
          this.active = !this.active;
          this.isFollow = !this.isFollow;
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    unlineMessageBox(){
      this.$messagebox({
        title: "温馨提示",
        message:
          "该医生有事已离线，您现在发起咨询，医生可能无法及时响应，是否确定发起咨询？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(action => {
        if(action == "confirm"){
          this.handleCounsulation();
        }
      });
    },
    //
    handleConsult(type) {
      if(!this.$store.getters.token){
        this.$router.push({ path: "/userReg", query: {platId: this.$route.query.platId,staffId:this.params.staffId}});
        return false;
      }
      let doc = this.doctorInfo;
      doc.consultType = this.channelType[this.isConsult][type];
      this.doctorInfo = doc;
      const channelTypeMap = {
        'img' : 'statusImage',
        'video' : 'statusVideo',
      }
      if ((this.isMini || type == "img") && this.doctorInfo[channelTypeMap[type]] === '1') { //是否开通该渠道
        // 医生离线无法视频咨询
        // if (this.doctorInfo.onlineStatus === '1'){
          if (type === 'video') {
              this.createForm();
          }
          // 医生在线、离线都可以发起图文咨询
          if (type  === 'img') {
            this.createForm()
          }
        // } else {
          // this.$toast("该医生已离线，暂时无法提供咨询服务")
        //   this.unlineMessageBox();
        // }

      } else {
        this.$toast("暂未开通该类型咨询渠道")
      }

    },
    /**
     * 关闭PickerComponent
     */
    closePicker() {
      this.pickerFlag = false;
    },
    createForm() {
      this.pickerFlag = false;
      this.$http
        .checkStatus({
          consultType: this.doctorInfo.consultType,
          doctorId: this.doctorInfo.staffId,
          source: "2",
          resDate: this.doctorInfo.resTime
        })
        .then(res => {
          // 0-成功、1-您已加入同个类别候诊队列、2已加入不同类别候诊队列、其他错误码-失败
          // 0-加入队列成功，即不存在订单，直接跳转病情描述
          if (res.status === "0") {
            this.handleCounsulation();
          // 1-已加入同个类别候诊队列，直接判断支付状态后跳转
          } else if (res.status === '1') {
            res.record.id && this.handleConsultInfo(res.record.id)

          // 2-已加入不同类别候诊队列
          } else if (res.status === '2') {
            this.$toast(res.msg)
          // 4-医生离线询问是否咨询
          } else if (res.status === '4') {
            this.unlineMessageBox();
          // 其他状态码-错误
          } else {
            this.$toast(res.msg)
          }
        })
    },
    handleConsultInfo(orderNo) {
      $services
        .getConsultInfoByOrderNo({
          orderNo: orderNo,
          userType: "01"
        })
        .then(res => {
          this.orderStatus = res.record.status
          // 未支付跳转订单详情
          if (this.orderStatus === '00') {
            this.$router.push({
              name: "recordInfo",
              query: {
                orderNo: orderNo
              }
            })
            // 其他情况跳转IM
          } else {
            // 判断当前环境
            if (this.isMini === true) {
              wx.miniProgram.navigateTo({
                url: "/pages/imChat/main?userType="+ "01" +"&orderNo=" + orderNo + "&sessionId=" + this.$store.getters.token
              })
            } else {
              this.$router.push({
                path: "/imChat",
                query: {
                  userType: "01",
                  orderNo: orderNo,
                  // 如果是同一个服务下,sessionId可以不传
                  // sessionId: this.$store.getters.token
                }
              })
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //
    handleCounsulation() {
      if (this.doctorInfo.consultType === '04' || this.doctorInfo.consultType === '02') { //视频先查询排班信息再跳转
        this.$http.getSchedulList({
          consultType: this.doctorInfo.consultType,
          deptId: this.doctorInfo.deptId,
          doctorId: this.doctorInfo.staffId,
          hospId: this.doctorInfo.phospId
        }).then(res => {
          if(res.length > 0) {
            this.pickerDataList = res;
            this.pickerFlag = true;
          } else {
            this.enterCounsulation();
          }
        })
      } else {
        this.enterCounsulation();
      }
    },
    //跳转
    enterCounsulation() {
      this.$router.push({
        name: "counsulation",
        query: {
          deptId: this.doctorInfo.deptId,
          deptName: this.doctorInfo.deptName,
          doctorId: this.doctorInfo.staffId,
          doctorName: this.doctorInfo.name,
          doctorProfessional: this.doctorInfo.postName,
          hospId: this.doctorInfo.phospId,
          hospName: this.doctorInfo.phospName,
          money: this.doctorInfo[this.costMap[this.doctorInfo.consultType]],
          consultType: this.doctorInfo.consultType,
          resTime: this.doctorInfo.resTime,
          numberId: this.doctorInfo.numberId,
          lockType: '02',
          isConsult: this.isConsult
        }
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/doctorInfo.vue